import { Trans, useTranslation } from 'react-i18next';

import { Icon } from '~/components';
import { cn } from '~/lib/cn';
import type { ArtistContact } from '~/modules/artist-roster/types';

import { ContactCard } from './ContactCard';

interface ContactCardsProps {
  contacts: ArtistContact[] | undefined;
}

export function ContactCards({ contacts }: ContactCardsProps) {
  const { t } = useTranslation('roster');
  const isMultiple = (contacts?.length ?? 0) > 1;

  if (!contacts?.length) {
    return null;
  }

  return (
    <>
      <div className="mb-md text-body-sm">
        <Trans
          t={t}
          i18nKey="contactInfo.hiddenMessage"
          components={{
            Icon: <Icon type="eye" variant="light" className="m-xs" />,
          }}
        />
      </div>
      <div
        className={cn({
          'grid grid-cols-2 gap-md': isMultiple,
        })}
      >
        {contacts.map((contact) => (
          <ContactCard key={contact.id} contact={contact} />
        ))}
      </div>
    </>
  );
}

ContactCards.displayName = 'ContactCards';
